/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
// Extends From
import Component from '@ember/component';
// Ember Imports

// Internal Imports
import AdministeredBy from 'linced-app/enums/medical/administered-by';
import AutoinjectorBrand from 'linced-app/enums/medical/autoinjector-brand';
import MedicationType from 'linced-app/enums/medical/medication-type';

export default class MedicationInformation extends Component {
  AdministeredBy = AdministeredBy;
  AutoinjectorBrand = AutoinjectorBrand;
  MedicationType = MedicationType;
  @tracked
  dialogOpen = false;
  medication = null;

  @action
  openDialog() {
    this.dialogOpen = true;
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
  }
}
